import React, { useState } from "react";
import { PiPrescription, PiPrescriptionFill } from "react-icons/pi";
import ConsultationService from "../../../Services/ConsultationService";
import dayjs from "dayjs";
import { DatePicker, message } from "antd";
import { RiVideoAddLine } from "react-icons/ri";
import { CiUser } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import Cardbg from "../../../Assets/Images/Svg/Namecard.svg";
import Inperson from "../../../Assets/Images/Svg/Person.svg";

function RepeatOrder({
  appointmentDetails,
  patientDetails,
  calculateAge,
  setIsPreviewModal,
  setPreviewData,
  setDrugPrescription,
  setActiveSection,
}) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [repeatConsultations, setRepeatConsultations] = useState();
  const [repeatIndex, setRepeatIndex] = useState();

  const handlePrescriptionRequest = async (fromDate, toDate) => {
    setLoading(true);
    const payload = {
      consultationId: appointmentDetails.consultationId,
      detailsYN: "Y",
      patientId: appointmentDetails.patientId,
      userId: appointmentDetails.userId,
    };

    if (fromDate && toDate) {
      payload.fromDate = dayjs(fromDate).format("MM/DD/YYYY");
      payload.toDate = dayjs(toDate).format("MM/DD/YYYY");
    }

    try {
      let result = await ConsultationService.getPrescriptions(payload);
      setRepeatConsultations(result.data);
      setOpen(true);
    } catch (e) {
      message.error("An Error Occured....");
    } finally {
      setLoading(false);
    }
  };

  const handleRepeatPreview = (payload) => {
    setPreviewData(payload);
    setIsPreviewModal(true);
  };

  const handleSelectedRepeat = (index) => {
    const selectedObj = repeatConsultations[index];
    if (selectedObj?.drugPrescription?.length === 0) {
      message.error("Selected order Medicine list is empty");
      return;
    } else {
      setDrugPrescription(selectedObj?.drugPrescription);
      setActiveSection("addMedicines");
      setOpen(false);
      setRepeatIndex(null);
    }
  };

  const handleMonthFilter = (value) => {
    if (!value) return;
    const from = dayjs(value).startOf("month").format("MM/DD/YYYY");
    const to = dayjs(value).endOf("month").format("MM/DD/YYYY");
    handlePrescriptionRequest(from, to);
  };

  return (
    <div className="">
      {loading && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50  z-50">
          <div className="spinner"></div>
        </div>
      )}
      <button
        id="refer"
        className="w-[102px] h-[28px] flex items-center justify-center gap-1 rounded-md bg-brand-primaryColor text-xs font-sans font-semibold text-white"
        onClick={handlePrescriptionRequest}
      >
        Repeat
        <PiPrescriptionFill className="text-white w-6 h-6" />
      </button>
      {open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-40">
          <div className="relative bg-white p-2 rounded-lg shadow-lg w-[48%] transform transition-all duration-300 scale-95 opacity-0 animate-fadeIn">
            {/* Close Icon */}

            <div className="mx-5">
              <div className="flex justify-between items-center mb-3">
                <h3>Repeat Order</h3>
                <div className="flex gap-2 items-center">
                  <DatePicker
                    picker="month"
                    className="w-36"
                    defaultValue={dayjs()}
                    onChange={handleMonthFilter}
                  />
                  <span
                    onClick={() => setOpen(false)}
                    className=" text-gray-500 hover:text-gray-700 b"
                  >
                    <IoClose className="w-6 h-6 text-red-800 border rounded-full " />
                  </span>
                </div>
              </div>
              <div className="flex justify-between font-sans font-medium text-sm rounded-lg">
                <div className="flex flex-col px-2 mt-2">
                  <div className="flex items-center text-sm font-sans text-black">
                    <label className="px-2">
                      {patientDetails?.firstName || patientDetails?.lastName
                        ? patientDetails?.firstName +
                          " " +
                          patientDetails?.lastName
                        : "..."}
                    </label>
                    <span className="text-gray-300">|</span>
                    <label className="px-2">
                      {patientDetails?.ageDob
                        ? calculateAge(patientDetails?.ageDob)
                        : ""}
                    </label>
                    <span className="text-gray-300">|</span>
                    <label className="px-2">
                      {patientDetails?.gender
                        ? patientDetails?.gender === "M"
                          ? "Male"
                          : "Female"
                        : "NA"}
                    </label>
                  </div>

                 
                </div>
              </div>

              <div className="h-80 overflow-y-scroll scrollHide mt-2">
                {repeatConsultations.map((item, i) => {
                  const isSelected = repeatIndex === i;
                  return (
                    <div
                      key={i}
                      onClick={() => setRepeatIndex(i)}
                      className={`mt-3 border-2 rounded-lg p-2 cursor-pointer transition-all duration-200 ${
                        isSelected
                          ? "border-[#004B73] bg-green-200 shadow-md"
                          : "border-[#B0CFD2] bg-[#FAFEFF] hover:border-[#004B73]/50 hover:bg-[#F0F9FC]"
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <span
                            className={`text-sm font-bold font-sans ${
                              isSelected ? "text-[#004B73]" : "text-blue-950"
                            }`}
                          >
                            {item.consultationReason}
                          </span>
                          <div className="flex gap-2">
                            <span className="text-xs font-sans font-medium text-gray-500">
                              {item.consultationDate}
                            </span>
                            <div className="flex items-center">
                              {item.consultationType == "Video Consultation" ? (
                                <RiVideoAddLine className="text-[#004B73] w-3.5 h-3.5" />
                              ) : (
                                <CiUser className="text-[#004B73] w-4 h-4" />
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-3 items-center">
                          <button
                            onClick={(e) => { e.stopPropagation(); handleRepeatPreview(item); }}
                            id="refer"
                            className="px-2 py-1 flex items-center justify-center gap-1 rounded bg-brand-primaryColor text-sm font-sans font-semibold text-white"
                          >
                            <PiPrescription className="text-white w-4 h-4" />
                          </button>
                          {/* {isSelected && (
                            <span className="w-4 h-4 rounded-full bg-[#004B73] flex items-center justify-center mr-1">
                              <svg viewBox="0 0 10 8" className="w-2.5 h-2.5" fill="none">
                                <path d="M1 4l2.5 2.5L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            </span>
                          )} */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <hr className="mt-2" />
            </div>

            <div className="flex justify-end font-sans font-medium gap-3 mt-5">
              <button
                onClick={() => setOpen(false)}
                className="px-3 py-1 bg-white rounded-md border border-gray-300 text-gray-600 text-sm"
              >
                Cancel
              </button>
              <button
                onClick={() => handleSelectedRepeat(repeatIndex)}
                className="px-3 py-1 rounded-md bg-brand-primaryColor text-white text-sm"
              >
                Repeat
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RepeatOrder;
